import type { ChainId } from '@cronos-app/sdk';
import {
  currentWallet,
  getAddEthereumChainParameter,
} from '@cronos-app/wallet';
import { useMutation } from '@tanstack/react-query';

import { useToast } from './useToast';

export const useSwitchNetwork = () => {
  const isConnected = currentWallet.useIsConnected();
  const toast = useToast();

  return useMutation({
    mutationFn: async (chainId: ChainId) => {
      const networkConfig = getAddEthereumChainParameter(chainId);
      if (!isConnected) return;

      await currentWallet.connect(networkConfig).catch((e) => {
        toast({
          status: 'error',
          title: null,
          description: e?.message,
        });
        throw e;
      });
    },
  });
};
